import WizeLogo from 'my-components/WizeLogo';

const rootCss = ({ palette }) => ({
  width: '0.5em',
  height: '0.5em',
  '.TL-logoFill': {
    fillOpacity: 0.2,
    fill: palette.common.black,
  },
});

export default function TokenLogo() {
  return <WizeLogo css={rootCss} logoDashClassName="TL-logoFill" logoTickClassName="TL-logoFill" />;
}
